
import { ScoreDisplay } from "../Report/ScoreDisplay";
import { CompetencyCard } from "../Report/CompetencyCard";
import { TitleBadge } from "../Report/TitleBadge";
import type { LearnerReport } from "../Data/reportData";
import { getTitleFromScore, getCommentary,getTagFromScore  } from "../Data/reportData"; // ## CHANGE 1
import "../Learner.css";

interface PerformancePageProps {
  data: LearnerReport;
  reportData?: any;
}

export function PerformancePage({ data, reportData }: PerformancePageProps) {



  /* =====================================================
     ✅ BACKEND VALUES
  ===================================================== */

  const learnerName =
    reportData.lenUsername;

  // show overall score ONLY if backend sends
  const overallScore =
    reportData?.overallScoreOutOf10;

  const questScores =
    reportData?.questScoreOutOf10 || {};

  /* =====================================================
     ## CHANGE 2 – Dynamic Title & Commentary
  ===================================================== */

  const dynamicTitle =
    overallScore !== undefined
      ? getTitleFromScore(overallScore)
      : data.title;

  const dynamicCommentary =
    overallScore !== undefined
      ? getCommentary(reportData, overallScore)
      : data.commentary;



const visibleCompetencies = data.competencies.map((comp, index) => {
  const questNo = index + 1;

  const backendScore = reportData?.questScoreOutOf10?.[questNo];



  return {
    name: comp.name,
    icon: comp.icon,

    // ✅ fallback 0 (avoid undefined crash)
    dynamicScore: backendScore ?? 0,

    // ✅ always generate tag
    dynamicTag: getTagFromScore(backendScore ?? 0),
  };
});

  /* =====================================================
     UI
  ===================================================== */

  return (
    <div className="report-page analytics-bg p-10 md:p-16 overflow-hidden h-full flex flex-col">

      {/* ================= HEADER ================= */}
      <div className="text-center mb-10">
        <p className="text-base tracking-[0.3em] uppercase text-cyan mb-3">
          Performance Dashboard
        </p>

        <h2 className="text-5xl font-light text-foreground tracking-wide">
          {reportData?.lenUsername}
        </h2>

        <div className="w-16 h-0.5 mx-auto mt-5 bg-gradient-to-r from-transparent via-cyan to-transparent" />
      </div>

      {/* ================= MAIN GRID ================= */}
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">

        {/* LEFT SIDE */}
        <div className="lg:col-span-5 flex flex-col items-center justify-start gap-6">

          <div className="w-full p-6 rounded-2xl bg-card/60 border border-border card-glow backdrop-blur-sm">

            {/* ## CHANGE 3 */}
            <TitleBadge title={dynamicTitle} learnerName={learnerName} />

          </div>

          {/* ✅ show only when backend overall score exists */}
          {overallScore !== undefined && (
            <div className="w-full p-6 rounded-2xl bg-card/60 border border-border card-glow backdrop-blur-sm">
              <p className="text-sm text-cyan uppercase tracking-[0.2em] text-center mb-4">
                Overall Performance
              </p>

              <ScoreDisplay score={overallScore} size="lg" />
            </div>
          )}

        </div>

        {/* RIGHT SIDE */}
        <div className="lg:col-span-7 flex flex-col justify-start gap-6">

          {/* Summary always static */}
          <div className="p-5 rounded-xl bg-gradient-to-br from-card/80 to-card/40 border border-border/80 flex flex-col justify-center">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-2 h-2 rounded-full bg-cyan animate-pulse-soft" />
              <span className="text-sm uppercase tracking-widest text-foreground">
                Performance Summary
              </span>
            </div>

            <p className="text-base text-muted-foreground leading-relaxed">
              {dynamicCommentary}
            </p>
          </div>

          {/* ✅ heading only if backend data exists */}
          {visibleCompetencies.length > 0 && (
            <div className="px-2">
              <h3 className="text-2xl font-medium text-foreground">
                Competency Analytics
              </h3>
              <p className="text-base text-muted-foreground mt-1">
                Performance breakdown by skill area
              </p>
            </div>
          )}

          {/* ================= QUEST SCORE CARDS ================= */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

          


{visibleCompetencies.length > 0 && visibleCompetencies.map((comp: any, i) => (
  <CompetencyCard
    key={i}
    name={comp.name}
    icon={comp.icon}
    score={comp.dynamicScore}
    tag={comp.dynamicTag}
  />
))}

          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-auto pt-3 text-base text-muted-foreground italic">
        <span>Rating Range: 0–10, Based on Final Score</span>
      </div>
    </div>
  );
}
